export default __webpack_public_path__ + "static/media/navigation-variation-pill.eb3d8e13.svg";